module.exports = __webpack_public_path__ + "img/customer.9e4a8b69.svg";